import { isThisYear, isToday, isYesterday } from 'date-fns';
import { IntlShape, useIntl } from 'react-intl';

const getFormattedDate = (date: Date, intl: IntlShape): string => {
  if (isToday(date)) return intl.formatDate(date, { timeStyle: 'short' });
  if (isYesterday(date))
    return intl.formatRelativeTime(-1, 'day', { numeric: 'auto' });
  if (isThisYear(date))
    return intl.formatDate(date, { month: 'short', day: 'numeric' });
  return intl.formatDate(date, { dateStyle: 'medium' });
};

const useFormattedDate = (date: Date | undefined) => {
  const intl = useIntl();

  const formattedDate = date ? getFormattedDate(date, intl) : '';
  const formattedDateTime = date
    ? intl.formatDate(date, { dateStyle: 'full', timeStyle: 'medium' })
    : '';

  return { formattedDate, formattedDateTime };
};

export { useFormattedDate };
